import script from "./Home2.vue?vue&type=script&setup=true&lang=js"
export * from "./Home2.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./Home2.vue?vue&type=style&index=1&id=c12335e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c12335e0"]])

export default __exports__